<template>
    <el-container class="default">
         
    </el-container> 
</template>
<script>   
 
export default {  
     
}
</script>

<style  scoped>
/* ************************************搜索和操作区域样式，公用********************************** */
.default{
    margin:0;
    padding:0;
    width:100%;
    height:100%;
    background: #FFFFFF; 
    border-radius: 5px;
} 
</style>